import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faComments,
  faMagnifyingGlassChart,
  faSitemap,
  faPenRuler,
  faRocket,
  faArrowsSpin,
} from "@fortawesome/free-solid-svg-icons";
import "./Process.css";

const steps = [
  {
    title: "Understanding your vision",
    desc: "We start by listening. We learn your business, audience, and goals so every decision is aligned with where you want to go.",
    icon: faComments,
  },
  {
    title: "Evaluating the current state",
    desc: "If you already have a site, we review structure, content, performance, and usability to find the highest-impact improvements.",
    icon: faMagnifyingGlassChart,
  },
  {
    title: "Planning with purpose",
    desc: "We lock in structure, content flow, and technical direction early so the final deliverable is intentional and on track.",
    icon: faSitemap,
  },
  {
    title: "Designing & building",
    desc: "Clean layout, clear copy, and fast performance drive every design and development choice we make.",
    icon: faPenRuler,
  },
  {
    title: "Launching carefully",
    desc: "Before go-live we check responsiveness, performance, and core SEO so your launch is smooth and reliable.",
    icon: faRocket,
  },
  {
    title: "Growing together",
    desc: "After launch we support updates, improvements, and refinements as your business and needs evolve.",
    icon: faArrowsSpin,
  },
];

const Process = () => {
  return (
    <section className="about-process">
      <div className="about-process-wrap">
        <header className="about-process-head">
          <span className="about-process-kicker">Our process</span>
          <h2>How we work on every project</h2>
          <p>
            A clear, transparent process that keeps you in the loop and delivers results that last—no surprises.
          </p>
        </header>

        <div className="about-process-list">
          {steps.map((step, index) => (
            <div className="about-process-item" key={index}>
              <div className="about-process-icon">
                <FontAwesomeIcon icon={step.icon} />
              </div>

              <div className="about-process-content">
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
